import React, { useEffect, useState } from 'react'
import LoginForm from '../features/auth/LoginForm'
import { useAppSelector } from '../app/hooks'
import windowLocationRedirect from '../features/redirect'
import { Link } from 'react-router-dom'
import ApplicationLogo from '../components/ApplicationLogo'

export default function Login() {

    const { isAuthenticated, errorStatus } = useAppSelector((state) => state.auth)

    useEffect(() => {
        if (isAuthenticated){
            windowLocationRedirect("")
        }
    }, [])

    return(
        <div className="login-page-container">
            <div className="content-of-login-page-container">

                <div className="login-form-box-container">
                    <div className="content-of-login-form-box-container">

                        <div className="logo-box-of-login-form-box-container">
                            <div className="content-of-logo-box-of-login-form-box-container">
                                <ApplicationLogo />
                            </div>
                        </div>

                        <div className="text-box-of-login-form-box-container">
                            <div className="content-of-text-box-of-login-form-box-container">
                                {errorStatus === 401 ? <h2>Two-Factor Authentication</h2> : <h2>Sign in to your account</h2>}
                                {errorStatus === 401 ? <p>Enter 6-digit code from your authenticator app</p> : <p>Don’t have an account? <Link to="/sign-up">Get started</Link></p>}
                            </div>
                        </div>

                        <div className="form-of-login-form-box-container">
                            <div className="content-of-form-of-login-form-box-container">
                                <LoginForm />
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}